import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { OrderedMap } from 'immutable';
import pluralize from 'pluralize';
import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group';

import BookingsGroup from 'models/bookings-group';
import Brand from 'models/brand';

import Booking from 'components/bookings/active/booking';
import Paginate from 'components/common/paginate';

export const ACTIVE_BOOKINGS_LIMIT = 6;

const propTypes = {
  addMessageAndScrollToTop: PropTypes.func.isRequired,
  app: PropTypes.string.isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  events: PropTypes.instanceOf(OrderedMap),
  getBookings: PropTypes.func.isRequired,
  locations: PropTypes.instanceOf(OrderedMap),
  trackEvent: PropTypes.func.isRequired,
  upcomingBookings: PropTypes.instanceOf(BookingsGroup).isRequired,
};

const defaultProps = {
  events: OrderedMap(),
  locations: OrderedMap(),
};

class Active extends Component {
  constructor(props) {
    super(props);

    this.handlePageClick = this.handlePageClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.upcomingBookings.bookings.equals(this.props.upcomingBookings.bookings) && this.header) {
      window.scrollTo({ top: this.header.offsetTop, behavior: 'smooth' });
    }
  }

  handlePageClick(page) {
    this.props.getBookings({ page });
  }

  renderHeader() {
    const { totalCount } = this.props.upcomingBookings;

    return (
      <div ref={(header) => { this.header = header; }}>
        <h2 className="text-color-dark-slate margin-top-10 margin-bottom-0 text-size-20 text-weight-bold">
          YOUR SPACE IS WAITING
          <span className="margin-left-20 text-size-14 text-weight-book">{totalCount} { pluralize('Pass', totalCount) }</span>
        </h2>
      </div>
    );
  }

  renderPaginate() {
    const { paginationCurrentPage, paginationTotalPages } = this.props.upcomingBookings;

    return (
      <Fragment>
        <div className="hidden-xs hidden-sm pull-right">
          <Paginate
            maxMargin={4}
            onClick={this.handlePageClick}
            selectedPage={paginationCurrentPage}
            totalPages={paginationTotalPages}
          />
        </div>
        <div className="hidden-md hidden-lg pull-right">
          <Paginate
            maxMargin={2}
            onClick={this.handlePageClick}
            selectedPage={paginationCurrentPage}
            totalPages={paginationTotalPages}
          />
        </div>
      </Fragment>
    );
  }

  render() {
    const {
      addMessageAndScrollToTop,
      app,
      brand,
      events,
      locations,
      trackEvent,
      upcomingBookings,
    } = this.props;
    const {
      bookings,
      paginationTotalPages,
    } = upcomingBookings;

    if (!upcomingBookings.bookings.size) {
      return null;
    }

    return (
      <div className="booking-section active-bookings">
        <a className="nav-offset-anchor" id="active-bookings" />
        { this.renderHeader() }
        <div className="row">
          <TransitionGroup exit={false}>
            { bookings.valueSeq().map((booking, index) =>
              (<CSSTransition
                classNames="booking"
                key={`active-booking-${booking.id}`}
                timeout={500}
              >
                <Booking
                  addMessageAndScrollToTop={addMessageAndScrollToTop}
                  analyticsPosition={index}
                  app={app}
                  brand={brand}
                  booking={booking}
                  event={booking.getEvent(events)}
                  location={booking.getLocation(locations)}
                  trackEvent={trackEvent}
                />
              </CSSTransition>
              ),
            )}
          </TransitionGroup>
        </div>
        { paginationTotalPages > 1 && this.renderPaginate() }
      </div>
    );
  }
}

Active.propTypes = propTypes;
Active.defaultProps = defaultProps;

export default Active;
